import React, { useState, useEffect } from 'react'; // Combined imports
import Modal from './components/Modal'; 
import CookieBanner from './components/CookieBanner'; // Fixed path
import { privacyContent } from './constants/PrivacyPolicy'; // Check spelling
import { termsContent } from './constants/TermsofService';
import './utils/ads'; 
import './utils/analytics'; 
import './utils/cookies';
import './utils/ccpa'; 
import { Analytics } from "@vercel/analytics/react"
import About from './components/About';

// 1. Move AdUnit OUTSIDE the App function
const AdUnit = ({ slot }) => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("Ads error", e);
    }
  }, []);

  return (
    <div className="ad-container" style={{ margin: '20px 0', textAlign: 'center' }}>
      <ins className="adsbygoogle"
           style={{ display: 'block' }}
           data-ad-client="ca-pub-5295036182306895" // Replace with your real ID
           data-ad-slot={slot}
           data-ad-format="auto"
           data-full-width-responsive="true"></ins>
    </div>
  );
};

function App() {
  // 2. Simplified State
  const [role, setRole] = useState('');
  const [bio, setBio] = useState('');
  const [skills, setSkills] = useState('');
  const [copied, setCopied] = useState(false);
  const [modalType, setModalType] = useState(null); // Use this to track 'privacy' or 'terms'

  const LinkedInShareButton = () => {
    const handleShare = () => {
      const shareUrl = window.location.href.replace(window.location.origin, "https://probiosgen.com");
      const title = encodeURIComponent("Check out my new professional bio!");
      const summary = encodeURIComponent("I just used this AI Bio Generator to refresh my professional profile. Try it out!");
      const linkedInUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${shareUrl}&title=${title}&summary=${summary}`;
      window.open(linkedInUrl, '_blank', 'width=600,height=400');
    };
    return (
      <button onClick={handleShare} style={{ marginTop: '10px', background: '#0077b5', color: '#fff', border: 'none', padding: '10px', cursor: 'pointer' }}>
        Share on LinkedIn
      </button>
    );
  };


  const generateBio = () => {
    const templates = [
      `${role} dedicated to excellence in every project.`,
      `${role} with expertise in ${skills}, focused on delivering results.`,
      `${role} passionate about ${skills} and continuous learning.`,
      `Experienced ${role} specializing in ${skills}, driven to succeed.`,
      `Creative ${role} with a knack for ${skills} and problem-solving.`,
      `Results-oriented ${role} skilled in ${skills}, committed to growth.`,
      `Detail-focused ${role} with strong ${skills} abilities.`,
      `Innovative ${role} leveraging ${skills} to drive success.`,
      `Dynamic ${role} with a background in ${skills}, eager to contribute.`,
      `Versatile ${role} experienced in ${skills}, ready for new challenges.`,
      `Proactive ${role} with expertise in ${skills}, focused on excellence.`,
      `Ambitious ${role} skilled in ${skills}, striving for impactful results.`,
      `Passionate ${role} with a deep understanding of ${skills}.`,
      `Skilled ${role} dedicated to mastering ${skills} and delivering value.`,
      `Experienced ${role} with a strong foundation in ${skills}.`,
      `Detail-oriented ${role} with a passion for ${skills} and quality work.`,
      `Creative ${role} leveraging ${skills} to innovate and excel.`,
      `${role} with a passion for ${skills}, committed to excellence and innovation.`,
      `${skills} enthusiast and experienced ${role}, focused on creating impactful solutions.`,
      `${role} skilled in ${skills}, driven by a desire to make a difference through technology.`,
      `${role} experienced in ${skills}, ready to take on new challenges.${skills ? ` with a strong background in ${skills}.` : ''}`,
      `${role} who loves ${skills} and is always eager to learn more and grow professionally.`,
      `${role} with a solid foundation in ${skills}, aiming to contribute effectively to team success.`,
      `Dynamic ${role} with a focus on ${skills}, striving to deliver exceptional results in every endeavor.`,
      `Innovative ${role} with a passion for ${skills}, committed to pushing the boundaries of what is possible.`,
      `Experienced ${role} with a strong background in ${skills}, ready to tackle new challenges and drive success.`,
      `Passionate ${role} with expertise in ${skills}, dedicated to continuous improvement and excellence.`,  
      `Versatile ${role} skilled in ${skills}, focused on delivering high-quality solutions and exceeding expectations.`,
      `Results-driven ${role} with a deep understanding of ${skills}, committed to achieving outstanding outcomes.`,
      `Skilled ${role} with a passion for ${skills}, eager to contribute to innovative projects and team success.`,
      `Detail-oriented ${role} with expertise in ${skills}, dedicated to delivering top-notch results.`,
      `Proactive ${role} with a strong foundation in ${skills}, ready to take on new challenges and drive innovation.`,
      `Ambitious ${role} with a focus on ${skills}, striving to make a meaningful impact in the industry.`, 
      `Innovative ${role} with a passion for ${skills}, eager to contribute to cutting-edge projects and team success.`,
      `Experienced ${role} with a strong background in ${skills}, ready to tackle new challenges and drive success.`,
      `Passionate ${role} with expertise in ${skills}, dedicated to continuous improvement and excellence.`,  
      `Skilled ${role} with a passion for ${skills}, eager to contribute to innovative projects and team success.`,
      `Detail-oriented ${role} with expertise in ${skills}, dedicated to delivering top-notch results.`,
      `Proactive ${role} with a strong foundation in ${skills}, ready to take on new challenges and drive innovation.`,
    ];
    setBio(templates[Math.floor(Math.random() * templates.length)]);
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(bio);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy!', err);
    }
  };

  return (
    <div style={{ maxWidth: '600px', margin: 'auto', padding: '40px', fontFamily: 'sans-serif' }}>

      <h1 style={{ textAlign: 'left', fontSize: '2em', fontWeight: 'bold', color: '#317ef0' }}>✨ Quick Pro Bio Generator</h1>
      
      <AdUnit slot="1234567890" />

      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <p>Enter your job title and skills to generate a professional bio:</p>
        <input 
          placeholder="Job Title (e.g. Software Engineer, Product Manager, Designer, Office Administrator)" 
          onChange={(e) => setRole(e.target.value)}
          style={{ padding: '10px' }}
        />
        <input 
          placeholder="Skills (e.g. React, Python, Design, Project Management, Communication, Leadership)" 
          onChange={(e) => setSkills(e.target.value)}
          style={{ padding: '10px' }}
        />
        <button 
          onClick={generateBio}
          style={{ padding: '10px', background: '#007bff', color: '#fff', border: 'none', cursor: 'pointer' }}
        >
   
          Generate My Bio
        </button>
        <section className="about-section" style={{ marginTop: '40px', textAlign: 'left', fontSize: '0.9rem', color: '#475569' }}>
  <h3>How the AI Bio Generator Works</h3>
  <p>Our tool uses professional templates to help job seekers and creatives craft the perfect first impression. By analyzing your role and key skills, we generate bios optimized for LinkedIn and professional resumes.</p>
</section><LinkedInShareButton />

      </div>

      {bio && (
        <div style={{ marginTop: '20px', padding: '15px', background: '#f4f4f4', borderRadius: '8px' }}>
          <h3>Your New Bio:</h3>
          <p>{bio}</p>
          <button onClick={copyToClipboard} style={{ marginTop: '10px' }}>
            {copied ? '✓ Copied!' : 'Copy to Clipboard'}
          </button>
        </div>
      )}



<section className="about-section" style={{ marginTop: '40px', textAlign: 'left', fontSize: '0.9rem', color: '#475569' }}>
  <h3>About Pro BioGen AI</h3>
  <p>
    Pro BioGen AI was created to solve a common problem: the "blank page" syndrome. 
    Writing about yourself is hard. Whether you are updating your LinkedIn profile, 
    refreshing your resume, or setting up a new professional Twitter account, 
    our human-curated templates and expertly designed provide a professional foundation in seconds.
  </p>
  
  <h3>Why use a Bio Generator?</h3>
  <ul style={{ textAlign: 'left', display: 'inline-block', marginTop: '10px' }}>
    <li>✅ <strong>Save Time:</strong> No more staring at a blinking cursor.</li>
    <li>✅ <strong>Professional Tone:</strong> Templates designed by career experts.</li>
    <li>✅ <strong>SEO Friendly:</strong> Optimized for recruiters and search algorithms.</li>
  </ul>
</section>
<About />
      {/* In your footer, use anchors styled as buttons to help Google trigger the Vignette */}
<footer style={{ marginTop: '50px', textAlign: 'center' }}>
 
  <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
    <a 
      href="#terms" 
      onClick={(e) => { e.preventDefault(); setModalType('terms'); }}
      className="legal-link"
    >
      Terms of Use
     
    </a>
  </div>
</footer>
      
      <footer style={{ marginTop: '50px', fontSize: '12px', textAlign: 'center' }}>
        <p>© 2026 Pro Bio Generator</p>
        <button onClick={() => setModalType('privacy')} style={{ background: 'none', border: 'none', color: 'blue', cursor: 'pointer', marginRight: '10px' }}>
          Privacy Policy
        </button>
          
        <button onClick={() => setModalType('terms')} style={{ background: 'none', border: 'none', color: 'blue', cursor: 'pointer' }}>
          Terms of Use
        </button>
     
      </footer>

  
      <CookieBanner /> 
    
<Analytics/> 
      
      <AdUnit slot="0987654321" />

      {/* 3. Single Modal Component for both policies */}
      <Modal 
        isOpen={modalType !== null} 
        onClose={() => setModalType(null)}
        title={modalType === 'privacy' ? 'Privacy Policy' : modalType === 'terms' ? 'Terms of Use' : 'About Pro BioGen AI'}
      >
        <div dangerouslySetInnerHTML={{ __html: modalType === 'privacy' ? privacyContent : modalType === 'terms' ? termsContent : About }} />
      </Modal>
    </div>
  );


}
export default App;